export default class Config {

    public static CONTACT_MAP_SRC = "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d2165.0383474807136!2d-0.09311458920954233!3d39.87812197602286!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1ses!2ses!4v1600195449330!5m2!1ses!2ses";
}

export class AppIcon {
    public static MENU: string = 'fas fa-bars';
    public static ARROW_TOP: string = 'fas fa-angle-up';
    public static ADDRESS: string = 'fas fa-map-marker-alt';
    public static ENVELOP: string = 'fas fa-envelope';
    public static AT: string = 'fas fa-at';
    public static PHONE: string = 'fas fa-phone';
    public static FACEBOOK: string = 'fab fa-facebook';

    public static COVID: string = 'fas fa-virus-slash';
    public static CLOSE: string = 'fas fa-times';

    public static DOWNLOAD: string = 'fas fa-download';
}

export class ContactInfo {
    public static MAIL: string = 'arcborriana@gmail.com';
    public static PHONE: string = '+34 667 09 69 39';
    public static FACEBOOK: string = 'https://www.facebook.com/groups/213420072780647';
}
